var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerElement',{attrs:{"fluid":_vm.fluid}},[_c(_vm.component,_vm._g(_vm._b({tag:"component",class:_vm.marginClasses,attrs:{"id":`c${_vm.id}`,"type":_vm.type,"links":_vm.links,"meta":_vm.meta,"attributes":_vm.attributes,"relationships":_vm.relationships}},'component',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }